"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.icertisUploadFeedback = exports.NavigationDrawer = void 0;
var React = _interopRequireWildcard(require("react"));
var _zod = require("zod");
var _AuthContext = require("../../context/AuthContext");
var _addinLogout = require("../../utils/addin-logout");
var _envManager = require("../../utils/envManager");
var _utils = require("@design/lib/utils");
var _PageContext = require("../../context/PageContext");
var _document = require("../../utils/document");
var _documentUploadGuard = require("../../utils/document-upload-guard");
var _cacheManager = require("../../utils/cacheManager");
var _constants = require("../../constants");
var _branding = require("../../utils/branding");
var _toast = require("../../utils/toast");
var _api = require("../../utils/api");
var _webApi = require("../../utils/web-api");
var _safeFetch = require("../../utils/safe-fetch");
var _useDioptraFetch2 = require("../../hooks/use-dioptra-fetch");
var _WordDocumentContext = require("../../context/WordDocumentContext");
var _useIcertisIntegration = require("../../hooks/useIcertisIntegration");
var _useIcertisUpload2 = require("../../hooks/useIcertisUpload");
var _useIcertisAuth2 = require("../../hooks/useIcertisAuth");
var _AnalyticsContext = require("../../context/AnalyticsContext");
var _hoverTooltip = require("@common/components/hover-tooltip");
var _backSheet = _interopRequireDefault(require("../ui/back-sheet"));
var _UploadToWorkflowNoteDialog = require("./UploadToWorkflowNoteDialog");
var _icertisAgreementLink = require("../../utils/icertis/icertis-agreement-link");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t7 in e) "default" !== _t7 && {}.hasOwnProperty.call(e, _t7) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t7)) && (i.get || i.set) ? o(f, _t7, i) : f[_t7] = e[_t7]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var icertisAgreementContextSchema = _zod.z.object({
  entityName: _zod.z.string().trim().min(1).max(256),
  sysId: _zod.z.string().trim().min(1).max(256)
});
var ICERTIS_RECONNECT_MESSAGE = "Your Icertis connection has expired. Reconnect from the Icertis menu, then upload again.";
var ICERTIS_RETRY_PROMPT = "My Icertis upload failed. Can you try uploading it again?";
var baseIcertisUploadFeedback = function baseIcertisUploadFeedback(diagnosis, errorMessage, entityName, sysId, connectedHost) {
  var failure = "Upload failed: \"".concat(errorMessage, "\". Agreement: ").concat(entityName, "/").concat(sysId, ".");
  if (!diagnosis) {
    return {
      kind: "actionable",
      message: errorMessage,
      actionLabel: "Ask agent to try",
      prompt: ICERTIS_RETRY_PROMPT,
      agentContext: "".concat(failure, " The pre-flight check did not run, so verify the connection (check_icertis_auth) and that the agreement resolves (get_agreement_attributes) before retrying the upload once, and tell the user plainly what you found.")
    };
  }
  switch (diagnosis.state) {
    case "not_connected":
    case "connection_expired":
      return {
        kind: "dismissible",
        message: ICERTIS_RECONNECT_MESSAGE
      };
    case "agreement_forbidden":
      return {
        kind: "dismissible",
        message: "Your Icertis account doesn't have permission to access this agreement."
      };
    case "agreement_missing":
      {
        var connectedInstance = connectedHost ? " (".concat(connectedHost, ")") : "";
        return {
          kind: "actionable",
          message: "This agreement was not found in the Icertis instance you're connected to".concat(connectedInstance, ". It may have been deleted there, or the document may have come from a different Icertis instance."),
          actionLabel: "Ask agent for options",
          prompt: "My Icertis upload was blocked because the agreement can't be found in the connected instance. What are my options?",
          agentContext: "".concat(failure, " The connection is live and this agreement does not resolve in the connected Icertis instance").concat(connectedInstance, " - both already checked, so do not call check_icertis_auth or look the agreement up again, and do not retry the upload. Icertis says the record is not there; it does not say why. The likely causes are that it was deleted, that this document came from a different Icertis environment, or that the account cannot see it. Ask the user whether the document came from ").concat(connectedHost !== null && connectedHost !== void 0 ? connectedHost : "the connected instance", " or another Icertis environment, and whether they can still see the agreement in Icertis themselves - offer to create a new agreement from this document (create_agreement/upload_document) once they answer. Wait for their answer.")
        };
      }
    case "agreement_unreadable":
      return {
        kind: "actionable",
        message: errorMessage,
        actionLabel: "Ask agent to try",
        prompt: ICERTIS_RETRY_PROMPT,
        agentContext: "".concat(failure, " The connection is live, but Icertis returned HTTP ").concat(diagnosis.httpStatus, " when reading this agreement. Look the agreement up (get_agreement_attributes) to see whether it is readable at all, retry the upload once, and report the outcome.")
      };
    case "agreement_found":
      {
        var agreementState = [diagnosis.name ? "\"".concat(diagnosis.name, "\"") : null, diagnosis.businessStatus ? "business status ".concat(diagnosis.businessStatus) : null, diagnosis.status ? "status ".concat(diagnosis.status) : null, diagnosis.isPublished === false ? "not published" : null].filter(Boolean).join(", ");
        return {
          kind: "actionable",
          message: errorMessage,
          actionLabel: "Ask agent to try",
          prompt: ICERTIS_RETRY_PROMPT,
          agentContext: "".concat(failure, " The connection is live and the agreement resolves (").concat(agreementState, ") - both already checked, so skip check_icertis_auth and the agreement lookup. Say whether that state is one Icertis blocks uploads for, then retry the upload once and report the outcome. If it fails the same way, tell the user a recent redline can leave the document's internal formatting in a state Icertis rejects even though Word opens it fine.")
        };
      }
  }
};
var NON_LINKABLE_DIAGNOSIS_STATES = new Set(["not_connected", "connection_expired", "agreement_missing", "agreement_forbidden"]);
var icertisUploadFeedback = exports.icertisUploadFeedback = function icertisUploadFeedback(diagnosis, errorMessage, entityName, sysId, connectedHost, icmBaseUrl) {
  var feedback = baseIcertisUploadFeedback(diagnosis, errorMessage, entityName, sysId, connectedHost);
  if (!icmBaseUrl || !entityName || !sysId) {
    return feedback;
  }
  if (diagnosis && NON_LINKABLE_DIAGNOSIS_STATES.has(diagnosis.state)) {
    return feedback;
  }
  try {
    return _objectSpread(_objectSpread({}, feedback), {}, {
      remediationUrl: (0, _icertisAgreementLink.buildIcertisAgreementLink)({
        icmBaseUrl: icmBaseUrl,
        entityName: entityName,
        sysId: sysId
      })
    });
  } catch (_unused) {
    return feedback;
  }
};
var NavigationDrawer = exports.NavigationDrawer = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    className = _ref.className;
  var _usePage = (0, _PageContext.usePage)(),
    showPage = _usePage.showPage;
  var handleLogout = function handleLogout() {
    return (0, _addinLogout.logOutOfAddin)(authHeader);
  };
  var accountPageUrl = function () {
    var authUrl = (0, _envManager.getEnv)("AUTH_URL");
    return authUrl ? "".concat(authUrl.replace(/\/$/, ""), "/account") : "";
  }();
  var pluginVersion = (0, _envManager.getPluginVersion)();
  var _useAuthInfo = (0, _AuthContext.useAuthInfo)(),
    user = _useAuthInfo.user;
  var instance = "";
  try {
    instance = new URL((0, _envManager.getEnv)("WEBAPP_API_BASE_URL")).hostname;
  } catch (_unused2) {
    // leave instance empty when the base URL is missing or malformed
  }
  var authHeader = (0, _AuthContext.useAuthHeader)();
  var _useWordDocument = (0, _WordDocumentContext.useWordDocument)(),
    documentName = _useWordDocument.documentName;
  var _useIcertisIntegratio = (0, _useIcertisIntegration.useIcertisIntegration)(),
    icertisStatus = _useIcertisIntegratio.status,
    icmBaseUrl = _useIcertisIntegratio.icmBaseUrl,
    icertisInstanceMismatch = _useIcertisIntegratio.mismatch,
    isLoadingIcertisIntegration = _useIcertisIntegratio.isLoading,
    refreshIcertisIntegration = _useIcertisIntegratio.refresh;
  var _useIcertisUpload = (0, _useIcertisUpload2.useIcertisUpload)(),
    canUpload = _useIcertisUpload.canUpload,
    disabledReason = _useIcertisUpload.disabledReason,
    isLoadingProperties = _useIcertisUpload.isLoading,
    uploadToIcertis = _useIcertisUpload.uploadToIcertis;
  var _useIcertisAuth = (0, _useIcertisAuth2.useIcertisAuth)(),
    authenticateAndReactivate = _useIcertisAuth.authenticateAndReactivate;
  var _useDioptraFetch = (0, _useDioptraFetch2.useDioptraFetch)(),
    dioptraFetch = _useDioptraFetch.dioptraFetch;
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    analytics = _useAnalytics.analytics,
    sendError = _useAnalytics.sendError;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    uploadSuccess = _React$useState2[0],
    setUploadSuccess = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isUploadNoteDialogOpen = _React$useState4[0],
    setIsUploadNoteDialogOpen = _React$useState4[1];
  var _React$useState5 = React.useState(""),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    uploadNote = _React$useState6[0],
    setUploadNote = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isUploadToWorkflowRunning = _React$useState8[0],
    setIsUploadToWorkflowRunning = _React$useState8[1];
  if (!isOpen) return null;
  var handleItemClick = function handleItemClick(item) {
    if (item.isVersion) {
      return;
    }
    if (item.onClick) {
      item.onClick();
      // Don't close drawer for upload actions - let user see success/error feedback
      if (item.isUploading !== undefined) {
        return;
      }
    } else if (item.isLink && item.href) {
      if (item.href.startsWith("mailto:")) {
        window.location.href = item.href;
      } else {
        window.open(item.href, "_blank", "noopener,noreferrer");
      }
    } else if (item.page) {
      showPage(item.page);
    }
    onClose();
  };
  var handleResetFileMetadata = function handleResetFileMetadata() {
    (0, _document.withWordContextWrite)(/*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(context) {
        var docProperties, dioptraProperties, settings, chatConversationSetting, bookmarks;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              docProperties = context.document.properties.load();
              _context.n = 1;
              return context.sync();
            case 1:
              dioptraProperties = docProperties.comments.split(/\s/).filter(function (prop) {
                return prop.startsWith("dioptra_");
              });
              dioptraProperties.forEach(function (prop) {
                docProperties.comments = docProperties.comments.replace(prop, "");
              });
              settings = context.document.settings;
              chatConversationSetting = settings.getItemOrNullObject(_constants.DIOPTRA_CHAT_CONVERSATION_ID);
              chatConversationSetting.load("value");
              _context.n = 2;
              return context.sync();
            case 2:
              if (!chatConversationSetting.isNullObject) {
                chatConversationSetting.delete();
              }
              bookmarks = context.document.body.getRange().getBookmarks(true);
              _context.n = 3;
              return context.sync();
            case 3:
              bookmarks.value.forEach(function (bookmarkName) {
                if (bookmarkName.startsWith("_dioptra_")) {
                  context.document.deleteBookmark(bookmarkName);
                }
              });
              _context.n = 4;
              return _cacheManager.cacheManager.clearCache();
            case 4:
              localStorage.clear();
              (0, _toast.toastSuccess)("File metadata reset successfully, reloading...");
              setTimeout(function () {
                window.location.reload();
              }, 2000);
            case 5:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }()).catch(function (err) {
      console.error("Failed to remove file metadata:", err);
    });
  };
  var handleUnlockDocument = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var documentBase64, currentDocName, unlockedUrl, response, blob, downloadWindow, blobUrl, link, _t;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _context2.p = 0;
            _context2.n = 1;
            return (0, _documentUploadGuard.readDocumentWithinUploadLimit)();
          case 1:
            documentBase64 = _context2.v;
            if (!(documentBase64 === null)) {
              _context2.n = 2;
              break;
            }
            return _context2.a(2);
          case 2:
            currentDocName = documentName || "document.docx";
            if (authHeader) {
              _context2.n = 3;
              break;
            }
            return _context2.a(2);
          case 3:
            _context2.n = 4;
            return (0, _api.removeDocumentProtection)(authHeader, documentBase64, currentDocName);
          case 4:
            unlockedUrl = _context2.v;
            _context2.n = 5;
            return (0, _safeFetch.safeFetch)(unlockedUrl);
          case 5:
            response = _context2.v;
            _context2.n = 6;
            return response.blob();
          case 6:
            blob = _context2.v;
            // Try using the presigned URL directly with window.open
            downloadWindow = window.open(unlockedUrl, "_blank");
            if (!downloadWindow) {
              // If popup blocked, try blob URL download
              blobUrl = URL.createObjectURL(blob);
              link = document.createElement("a");
              link.href = blobUrl;
              link.download = "unlocked_".concat(currentDocName);
              link.style.display = "none";
              document.body.appendChild(link);
              link.click();
              setTimeout(function () {
                document.body.removeChild(link);
                URL.revokeObjectURL(blobUrl);
              }, 1000);
            }
            (0, _toast.toastSuccess)("Document unlocked and downloaded!");
            _context2.n = 8;
            break;
          case 7:
            _context2.p = 7;
            _t = _context2.v;
            console.error("Failed to unlock document:", _t);
            (0, _toast.toastError)("Failed to unlock document: ".concat(_t instanceof Error ? _t.message : "Please try again."));
          case 8:
            return _context2.a(2);
        }
      }, _callee2, null, [[0, 7]]);
    }));
    return function handleUnlockDocument() {
      return _ref3.apply(this, arguments);
    };
  }();
  var connectedIcertisHost = function () {
    try {
      return icmBaseUrl ? new URL(icmBaseUrl).hostname : null;
    } catch (_unused3) {
      return null;
    }
  }();
  var readIcertisAgreementContext = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var _yield$Promise$all, _yield$Promise$all2, entityName, sysId, parsedAgreementContext, _t2;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            _context3.p = 0;
            _context3.n = 1;
            return Promise.all([(0, _document.fetchCustomProperty)("EntityName"), (0, _document.fetchCustomProperty)("SysId")]);
          case 1:
            _yield$Promise$all = _context3.v;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            entityName = _yield$Promise$all2[0];
            sysId = _yield$Promise$all2[1];
            parsedAgreementContext = icertisAgreementContextSchema.safeParse({
              entityName: entityName,
              sysId: sysId
            });
            return _context3.a(2, parsedAgreementContext.success ? parsedAgreementContext.data : null);
          case 2:
            _context3.p = 2;
            _t2 = _context3.v;
            sendError(_t2 instanceof Error ? _t2 : new Error(String(_t2)), {
              component: "NavigationDrawer",
              action: "read_icertis_agreement_context"
            });
            return _context3.a(2, null);
        }
      }, _callee3, null, [[0, 2]]);
    }));
    return function readIcertisAgreementContext() {
      return _ref4.apply(this, arguments);
    };
  }();
  var showIcertisUploadFeedback = function showIcertisUploadFeedback(feedback, onRemediationOpen) {
    if (feedback.kind === "dismissible") {
      (0, _toast.toastDismissibleError)(feedback.message, undefined, feedback.remediationUrl, onRemediationOpen);
      return;
    }
    (0, _toast.toastActionableError)(feedback.message, {
      label: feedback.actionLabel,
      onClick: function onClick() {
        onClose();
        showPage(_PageContext.PAGES.chatPage, {
          initialPrompt: feedback.prompt,
          agentOnlyContext: feedback.agentContext,
          autoSend: true
        });
      }
    }, undefined, feedback.remediationUrl, onRemediationOpen);
  };
  var handleUploadToIcertis = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(note) {
      var needsReconnect, authErrorMessage, preflightContext, _preflight, preflight, uploadOutcome, _diagnosis, _diagnosis2, errorMessage, agreementContext, entityName, sysId, diagnosis, _t3, _t4, _t5, _t6;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            setIsUploadToWorkflowRunning(true);
            _context4.p = 1;
            needsReconnect = icertisStatus === "expired" || icertisStatus === "mismatch";
            if (!needsReconnect) {
              _context4.n = 7;
              break;
            }
            if (!(!icmBaseUrl || icertisStatus === "mismatch" && !icertisInstanceMismatch)) {
              _context4.n = 2;
              break;
            }
            (0, _toast.toastError)("Icertis connection details are unavailable. Reconnect from the Icertis menu, then upload again.");
            return _context4.a(2);
          case 2:
            if (icertisStatus === "mismatch" && icertisInstanceMismatch) {
              (0, _toast.toastWarning)("Your Icertis sign-in is for ".concat(icertisInstanceMismatch.connectedInstanceHost, ", but your organization uses ").concat(icertisInstanceMismatch.orgInstanceHost, ". Reconnecting to ").concat(icertisInstanceMismatch.orgInstanceHost, "."));
            }
            _context4.p = 3;
            _context4.n = 4;
            return authenticateAndReactivate(icmBaseUrl);
          case 4:
            refreshIcertisIntegration();
            // Give the refreshed status time to settle before uploading.
            _context4.n = 5;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 500);
            });
          case 5:
            _context4.n = 7;
            break;
          case 6:
            _context4.p = 6;
            _t3 = _context4.v;
            console.error("Failed to authenticate Icertis:", _t3);
            authErrorMessage = _t3 instanceof Error ? _t3.message : "Failed to authenticate with Icertis";
            (0, _toast.toastError)(authErrorMessage);
            sendError(_t3, {
              component: "NavigationDrawer",
              action: "authenticate_icertis"
            });
            return _context4.a(2);
          case 7:
            _context4.n = 8;
            return readIcertisAgreementContext();
          case 8:
            preflightContext = _context4.v;
            if (!preflightContext) {
              _context4.n = 13;
              break;
            }
            preflight = null;
            _context4.p = 9;
            _context4.n = 10;
            return (0, _webApi.diagnoseIcertisUpload)(dioptraFetch, preflightContext.entityName, preflightContext.sysId);
          case 10:
            preflight = _context4.v;
            _context4.n = 12;
            break;
          case 11:
            _context4.p = 11;
            _t4 = _context4.v;
            sendError(_t4 instanceof Error ? _t4 : new Error(String(_t4)), {
              component: "NavigationDrawer",
              action: "preflight_icertis_upload"
            });
          case 12:
            if (!(((_preflight = preflight) === null || _preflight === void 0 ? void 0 : _preflight.state) === "agreement_missing")) {
              _context4.n = 13;
              break;
            }
            showIcertisUploadFeedback(icertisUploadFeedback(preflight, "The upload was blocked before sending because the agreement could not be found.", preflightContext.entityName, preflightContext.sysId, connectedIcertisHost, icmBaseUrl !== null && icmBaseUrl !== void 0 ? icmBaseUrl : null));
            return _context4.a(2);
          case 13:
            _context4.n = 14;
            return uploadToIcertis(note);
          case 14:
            uploadOutcome = _context4.v;
            if (!(uploadOutcome !== "uploaded")) {
              _context4.n = 15;
              break;
            }
            return _context4.a(2);
          case 15:
            setUploadNote("");
            setUploadSuccess(true);
            setTimeout(function () {
              setUploadSuccess(false);
            }, 1000);
            _context4.n = 24;
            break;
          case 16:
            _context4.p = 16;
            _t5 = _context4.v;
            console.error("Failed to upload to Icertis:", _t5);
            errorMessage = _t5 instanceof Error ? _t5.message : "The document couldn't be uploaded";
            sendError(_t5, {
              component: "NavigationDrawer",
              action: "upload_to_icertis"
            });

            // A 403 means Icertis denied the account the upload privilege — no
            // diagnosis, retry, or reconnect can change that, so say it plainly.
            if (!(_t5.status === 403)) {
              _context4.n = 17;
              break;
            }
            (0, _toast.toastDismissibleError)(errorMessage);
            return _context4.a(2);
          case 17:
            _context4.n = 18;
            return readIcertisAgreementContext();
          case 18:
            agreementContext = _context4.v;
            if (agreementContext) {
              _context4.n = 19;
              break;
            }
            (0, _toast.toastDismissibleError)(errorMessage);
            return _context4.a(2);
          case 19:
            entityName = agreementContext.entityName, sysId = agreementContext.sysId;
            diagnosis = null;
            _context4.p = 20;
            _context4.n = 21;
            return (0, _webApi.diagnoseIcertisUpload)(dioptraFetch, entityName, sysId);
          case 21:
            diagnosis = _context4.v;
            _context4.n = 23;
            break;
          case 22:
            _context4.p = 22;
            _t6 = _context4.v;
            sendError(_t6 instanceof Error ? _t6 : new Error(String(_t6)), {
              component: "NavigationDrawer",
              action: "diagnose_icertis_upload"
            });
          case 23:
            if (((_diagnosis = diagnosis) === null || _diagnosis === void 0 ? void 0 : _diagnosis.state) === "connection_expired" || ((_diagnosis2 = diagnosis) === null || _diagnosis2 === void 0 ? void 0 : _diagnosis2.state) === "not_connected") {
              refreshIcertisIntegration();
            }
            showIcertisUploadFeedback(icertisUploadFeedback(diagnosis, errorMessage, entityName, sysId, connectedIcertisHost, icmBaseUrl !== null && icmBaseUrl !== void 0 ? icmBaseUrl : null), function () {
              return analytics === null || analytics === void 0 ? void 0 : analytics.track("icertis_remedy_link_opened", {
                agreementId: sysId,
                contractTypeName: entityName
              });
            });
          case 24:
            _context4.p = 24;
            setIsUploadToWorkflowRunning(false);
            return _context4.f(24);
          case 25:
            return _context4.a(2);
        }
      }, _callee4, null, [[20, 22], [9, 11], [3, 6], [1, 16, 24, 25]]);
    }));
    return function handleUploadToIcertis(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();
  var handleUploadToWorkflowClicked = function handleUploadToWorkflowClicked() {
    setIsUploadNoteDialogOpen(true);
    analytics === null || analytics === void 0 || analytics.track("icertis_upload_note_dialog_opened");
  };
  var handleUploadNoteConfirmed = function handleUploadNoteConfirmed() {
    if (!isUploadNoteDialogOpen) return;
    setIsUploadNoteDialogOpen(false);
    void handleUploadToIcertis(uploadNote);
  };
  var sections = [].concat(_toConsumableArray(icertisStatus !== "not found" && !isLoadingIcertisIntegration ? [{
    title: "ICERTIS",
    items: [{
      label: icertisStatus === "expired" || icertisStatus === "mismatch" ? "Reconnect & upload" : "Upload to workflow",
      onClick: handleUploadToWorkflowClicked,
      isDisabled: !canUpload || isLoadingProperties || isUploadToWorkflowRunning,
      disabledTooltip: isLoadingProperties ? "Checking document properties..." : !canUpload ? disabledReason !== null && disabledReason !== void 0 ? disabledReason : undefined : undefined,
      isUploading: isUploadToWorkflowRunning,
      uploadSuccess: uploadSuccess
    }]
  }] : []), [{
    title: "MORE",
    items: [{
      label: "Network diagnostics",
      page: _PageContext.PAGES.networkDiagnosticsPage
    }, {
      label: "Remove document protection",
      onClick: handleUnlockDocument
    }, {
      label: "Reset file metadata",
      onClick: handleResetFileMetadata
    }, {
      label: "Reload ".concat((0, _branding.getBranding)().name, " add-in"),
      onClick: function onClick() {
        return window.location.reload();
      },
      hasSeparatorAfter: true
    }, {
      label: "Help",
      isLink: true,
      href: (0, _branding.getBranding)().supportUrl
    }, {
      label: "Account ↗",
      isLink: true,
      href: accountPageUrl
    }, {
      label: "Logout",
      onClick: handleLogout
    }, {
      label: "".concat(instance, " ").concat(pluginVersion),
      isVersion: true
    }, {
      label: (user === null || user === void 0 ? void 0 : user.email) || "",
      isVersion: true
    }]
  }]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "fixed inset-x-0 top-0 bottom-[42px] z-modal bg-black/20",
      onClick: onClose
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_backSheet.default, {
      ref: ref,
      title: "Settings",
      backLabel: "Close settings",
      onBack: onClose,
      className: (0, _utils.cn)("items-start data-[side=right]:w-full data-[side=right]:max-w-[320px] data-[side=right]:sm:max-w-[320px]", className),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "flex-1 overflow-y-auto w-full px-2 pb-2 flex flex-col pt-2",
        children: sections.map(function (section, sectionIndex) {
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)(React.Fragment, {
            children: [sectionIndex > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "w-full px-4 py-2",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: "w-full h-px bg-gray-200"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "flex flex-col items-start p-0 gap-2 w-full",
              children: section.items.map(function (item, itemIndex) {
                var Component = item.isVersion ? "div" : "button";
                var isDisabled = item.isDisabled || false;
                var isUploadingState = item.isUploading || false;
                var uploadSuccessState = item.uploadSuccess || false;
                return /*#__PURE__*/(0, _jsxRuntime.jsxs)(React.Fragment, {
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_hoverTooltip.HoverTooltip, {
                    className: "flex w-full",
                    content: item.disabledTooltip,
                    active: isDisabled && !!item.disabledTooltip,
                    align: "start",
                    delayDuration: 100,
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Component, {
                      onClick: function onClick() {
                        return !isDisabled && handleItemClick(item);
                      },
                      disabled: isDisabled,
                      className: (0, _utils.cn)("flex flex-row justify-start items-center px-4 py-2 gap-2.5", "w-full h-11 transition-colors", item.isVersion ? "bg-white cursor-text" : "bg-white", item.isVersion ? "" : isDisabled ? "opacity-50 cursor-not-allowed" : !uploadSuccessState && "hover:bg-gray-50 cursor-pointer", uploadSuccessState && "bg-green-500 hover:bg-green-500", "relative"),
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        className: (0, _utils.cn)("text-body flex-1 text-left", item.isVersion ? "text-gray-400 select-text" : uploadSuccessState ? "text-white" : "text-black"),
                        children: isUploadingState ? "Uploading..." : item.label
                      }), uploadSuccessState && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        className: "absolute right-2.5 w-5 h-5 flex items-center justify-center",
                        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
                          width: "20",
                          height: "20",
                          viewBox: "0 0 20 20",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                            d: "M16.7071 5.29289C17.0976 5.68342 17.0976 6.31658 16.7071 6.70711L8.70711 14.7071C8.31658 15.0976 7.68342 15.0976 7.29289 14.7071L3.29289 10.7071C2.90237 10.3166 2.90237 9.68342 3.29289 9.29289C3.68342 8.90237 4.31658 8.90237 4.70711 9.29289L8 12.5858L15.2929 5.29289C15.6834 4.90237 16.3166 4.90237 16.7071 5.29289Z",
                            fill: "white"
                          })
                        })
                      }), isUploadingState && !uploadSuccessState && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        className: "absolute right-2.5 w-5 h-5 flex items-center justify-center",
                        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
                          className: "animate-spin",
                          width: "20",
                          height: "20",
                          viewBox: "0 0 20 20",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
                            cx: "10",
                            cy: "10",
                            r: "8",
                            stroke: "var(--muted-foreground)",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeDasharray: "32",
                            strokeDashoffset: "24"
                          })
                        })
                      })]
                    })
                  }), item.hasSeparatorAfter && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    className: "w-full px-4 py-2",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      className: "w-full h-px bg-gray-200"
                    })
                  })]
                }, itemIndex);
              })
            })]
          }, section.title);
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_UploadToWorkflowNoteDialog.UploadToWorkflowNoteDialog, {
        open: isUploadNoteDialogOpen,
        note: uploadNote,
        onNoteChange: setUploadNote,
        onCancel: function onCancel() {
          return setIsUploadNoteDialogOpen(false);
        },
        onUpload: handleUploadNoteConfirmed
      })]
    })]
  });
});
NavigationDrawer.displayName = "NavigationDrawer";